(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mc-phi-health-tracking"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSlider = (slider) => {
      if (slider.dataset.mcSliderReady === 'true') return;
      const track = slider.querySelector('[data-mc-sensor-track]');
      const slides = Array.from(slider.querySelectorAll('[data-mc-sensor-slide]'));
      const previous = slider.querySelector('[data-mc-sensor-prev]');
      const next = slider.querySelector('[data-mc-sensor-next]');
      const count = slider.querySelector('[data-mc-sensor-count]');
      if (!track || slides.length < 2 || !previous || !next || !count) return;
      slider.dataset.mcSliderReady = 'true';
      const currentIndex = () => Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / (track.clientWidth || 1))));
      const update = () => {
        const index = currentIndex();
        count.textContent = `${index + 1} / ${slides.length}`;
        previous.disabled = index === 0;
        next.disabled = index === slides.length - 1;
      };
      const goTo = (index) => track.scrollTo({ left: track.clientWidth * Math.max(0, Math.min(slides.length - 1, index)), behavior: 'smooth' });
      previous.addEventListener('click', () => goTo(currentIndex() - 1));
      next.addEventListener('click', () => goTo(currentIndex() + 1));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    };
    const initAll = (root) => root.querySelectorAll('[data-mc-sensor-slider]').forEach(initSlider);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
    else initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
